import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { DateField } from "@/components/DateField";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const PRIORITIES = { dusuk: "Düşük", normal: "Normal", yuksek: "Yüksek", acil: "Acil", yatirim: "Yatırım" };
export const PRIORITY_COLORS = {
  dusuk: "bg-slate-50 text-slate-600 border-slate-200", normal: "bg-blue-50 text-blue-700 border-blue-200",
  yuksek: "bg-amber-50 text-amber-700 border-amber-200", acil: "bg-rose-50 text-rose-700 border-rose-200",
  yatirim: "bg-violet-50 text-violet-700 border-violet-200",
};
const SOURCES = ["Muhtar", "Vatandaş", "Kurum", "CİMER", "Valilik / Kaymakamlık", "Diğer"];

const daysBetween = (a, b) => Math.max(0, Math.round((new Date(`${b}T00:00:00`) - new Date(`${a}T00:00:00`)) / 86400000));
const today = () => new Date().toLocaleDateString("sv-SE");

export function petitionDuration(p) {
  if (p.duration_manual) return p.duration_manual;
  if (!p.date) return "-";
  return `${daysBetween(p.date, p.end_date || p.last_action_date || today())} gün`;
}

export const PETITION_EXTRA_DEFAULTS = {
  record_no: "", source: "", request: "", priority: "normal", institution_ids: [], action_taken: "",
  muhtar_meeting_date: "", end_date: "", last_action_date: "", duration_manual: "",
};

const InstitutionPicker = ({ institutions, value, onChange }) => (
  <div className="flex flex-wrap gap-1.5" data-testid="petition-institutions">
    {institutions.length === 0 && <span className="text-xs text-slate-500">Önce Kurumlar sayfasından kurum ekleyin.</span>}
    {institutions.map((i) => {
      const on = value.includes(i.id);
      return (
        <button key={i.id} type="button" onClick={() => onChange(on ? value.filter((x) => x !== i.id) : [...value, i.id])}
                data-testid={`petition-institution-${i.id}`}
                className={`px-3 py-1 rounded-full text-xs border transition-colors ${on
                  ? "bg-emerald-700 text-white border-emerald-700" : "bg-white text-slate-700 border-slate-300 hover:border-emerald-600"}`}>
          {i.name}
        </button>
      );
    })}
  </div>
);

export const PetitionExtraFields = ({ form, setForm, institutions }) => {
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const setE = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <>
      <div>
        <Label>Kayıt Numarası</Label>
        <Input value={form.record_no} onChange={setE("record_no")} placeholder="Boşsa otomatik (örn. 2026/0001)"
               data-testid="petition-record-no-input" />
      </div>
      <div>
        <Label>Nereden Geldiği</Label>
        <Input value={form.source} onChange={setE("source")} list="petition-sources" placeholder="Listeden seçin veya yazın"
               data-testid="petition-source-input" />
        <datalist id="petition-sources">{SOURCES.map((s) => <option key={s} value={s} />)}</datalist>
      </div>
      <div>
        <Label>Öncelik Durumu</Label>
        <Select value={form.priority} onValueChange={set("priority")}>
          <SelectTrigger data-testid="petition-priority-select"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(PRIORITIES).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div>
        <Label>Muhtarla Görüşme Tarihi</Label>
        <DateField value={form.muhtar_meeting_date} onChange={set("muhtar_meeting_date")} className="w-full" testId="petition-muhtar-date-input" />
      </div>
      <div className="sm:col-span-2">
        <Label>Dilekçe Sahibinin Talebi</Label>
        <Textarea value={form.request} onChange={setE("request")} rows={2} data-testid="petition-request-input" />
      </div>
      <div className="sm:col-span-2">
        <Label>İlgilendirdiği Kurum(lar)</Label>
        <InstitutionPicker institutions={institutions} value={form.institution_ids} onChange={set("institution_ids")} />
      </div>
      <div className="sm:col-span-2">
        <Label>Dilekçeye Yapılan İşlem</Label>
        <Textarea value={form.action_taken} onChange={setE("action_taken")} rows={2} data-testid="petition-action-input" />
      </div>
      <div>
        <Label>Son İşlem Tarihi</Label>
        <DateField value={form.last_action_date} onChange={set("last_action_date")} className="w-full" testId="petition-last-action-date-input" />
      </div>
      <div>
        <Label>Bitiş Tarihi</Label>
        <DateField value={form.end_date} onChange={set("end_date")} className="w-full" testId="petition-end-date-input" />
      </div>
      <div className="sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 items-end">
        <div>
          <Label>Süre (elle, isteğe bağlı)</Label>
          <Input value={form.duration_manual} onChange={setE("duration_manual")} placeholder="Boşsa otomatik hesaplanır"
                 data-testid="petition-duration-manual-input" />
        </div>
        <div className="text-sm text-slate-600 pb-2" data-testid="petition-duration-auto">
          Süre: <span className="font-semibold text-slate-900">{petitionDuration(form)}</span>
          {!form.duration_manual && (
            <span className="block text-xs text-slate-500">
              Dilekçe tarihinden {form.end_date ? "bitiş tarihine" : form.last_action_date ? "son işlem tarihine" : "bugüne"} kadar
            </span>
          )}
        </div>
      </div>
    </>
  );
};
